/**
 * product-card-equalizer.js
 *
 * Equalizes the height of .product-card__media-wrapper elements within each
 * grid row so that product text content aligns at the same vertical position
 * regardless of individual image aspect ratios.
 */
(function () {
  var GRID_SEL = '.collection__grid, .auxiliary-collection__grid';
  var WRAPPER_SEL = '.product-card__media-wrapper';

  function equalizeGrid(grid) {
    var wrappers = Array.from(grid.querySelectorAll(WRAPPER_SEL));
    if (!wrappers.length) return;

    // Reset any previously applied min-heights so measurements are accurate
    wrappers.forEach(function (w) { w.style.minHeight = ''; });

    // Batch-read all bounding rects before writing to avoid layout thrashing
    var rects = wrappers.map(function (w) { return w.getBoundingClientRect(); });

    // Group wrappers by row using their rounded top position
    var rowMap = new Map();
    rects.forEach(function (rect, i) {
      var key = Math.round(rect.top);
      if (!rowMap.has(key)) rowMap.set(key, []);
      rowMap.get(key).push({ wrapper: wrappers[i], height: rect.height });
    });

    // Apply the tallest height as min-height to every wrapper in its row
    rowMap.forEach(function (items) {
      var maxH = Math.max.apply(null, items.map(function (x) { return x.height; }));
      items.forEach(function (x) { x.wrapper.style.minHeight = maxH + 'px'; });
    });
  }

  function equalizeAll() {
    document.querySelectorAll(GRID_SEL).forEach(equalizeGrid);
  }

  // Re-equalize on window resize (debounced)
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equalizeAll, 150);
  });

  // Re-equalize after filter/sort/pagination re-renders the product grid.
  // The collection JS dispatches a 'render' event on #ProductGridContainer
  // after replacing its innerHTML with filtered results.
  function attachRenderListener() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;
    container.addEventListener('render', function () {
      requestAnimationFrame(equalizeAll);
    });
  }

  function init() {
    // Shopify's image_tag sets explicit width/height attributes, so the browser
    // can compute layout heights before image data loads. requestAnimationFrame
    // ensures the browser has finished its initial layout pass.
    requestAnimationFrame(equalizeAll);

    // Belt-and-suspenders: re-run once all resources (including lazy images
    // that entered the viewport) have fully loaded.
    window.addEventListener('load', equalizeAll, { once: true });

    attachRenderListener();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
